import { useLocalStorage } from '@/hooks/useLocalStorage.hook';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

export const useJWT = () => {
  const {
    value: jwt,
    setItem: setJWT,
    removeItem: removeJWT,
  } = useLocalStorage<string>(StorageKeysEnum.jwt);

  const {
    value: usersJWT,
    setItem: setUsersJWT,
    removeItem: removeUsersJWT,
  } = useLocalStorage<string>(StorageKeysEnum.usersJwt);

  return { jwt, setJWT, removeJWT, usersJWT, setUsersJWT, removeUsersJWT };
};
